module.exports = __webpack_public_path__ + "img/checkon.9d08c8fc.svg";